export default "__VITE_ASSET__46387094__"